module.exports = __webpack_public_path__ + "img/slider_galery_7.48860cbe.jpg";